import { Injectable } from '@angular/core';
import { Partner } from './partner.model';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

export interface PartnerState extends EntityState<Partner> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'partner', idKey: 'RelationshipId' })
export class PartnerStore extends EntityStore<PartnerState> {

  constructor() {
    super();
  }
}
